import { AutomationExecutionStatusEnum, AutomationStatus } from '@repo/utils';

export const AUTOMATION_STATUS_CONFIG: Record<AutomationStatus, {
  color?: string;
}> = {
  [AutomationStatus.draft]: {
    color: 'default',
  },
  [AutomationStatus.published]: {
    color: 'success',
  },
  [AutomationStatus.unpublished]: {
    color: 'error',
  },
  [AutomationStatus.archived]: {
    color: 'warning',
  },
};

export const AUTOMATION_EXECUTION_STATUS_CONFIG: Record<AutomationExecutionStatusEnum, {
  color?: string;
}> = {
  [AutomationExecutionStatusEnum.SUCCESS]: {
    color: 'success',
  },
  [AutomationExecutionStatusEnum.PENDING]: {
    color: 'default',
  },
  [AutomationExecutionStatusEnum.RUNNING]: {
    color: 'warning',
  },
  [AutomationExecutionStatusEnum.FAILED]: {
    color: 'error',
  },
  [AutomationExecutionStatusEnum.TERMINATED]: {
    color: 'warning',
  },
};
